import { ContainerModule, interfaces } from 'inversify';
import { ISideNavigationStore, SideNavigationStore } from './SideNavigation.store';

export const sideNavigationModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(ISideNavigationStore.$).to(SideNavigationStore).inSingletonScope();
});
